export default '/build/108fb7cc.svg'